import { format, isBefore } from 'date-fns';
/* eslint-disable */
const appConfig = require('webpack-config-loader!../app-config.js');
/* eslint-enable */
const utf8 = require('utf8');

export function serializeSpecialChars (string) {
  try {
    var encoded = utf8.decode(string);
  } catch (e) {
    return string;
  }
  return encoded;
}

export function maskEventRemarks (event, status_updated_at, status, ev) {
  if (status === 'accepted' && event && event.toLowerCase().includes('accepted at')) {
    return "Your shipment has cleared customs and arrived at XORTING CENTER"
  } else if (event === "Processed by WMS" || event === "Processed by WASP") {
    return "Your shipment is packed and will be handed over to our forwarding partner.";
  } else if (event && event.toLowerCase().includes('not delivered due to an unforeseen event.')) {
    return 'Your shipment will be scheduled for redelivery within 2 days.';
  } else if (event && event.toLowerCase().includes('estimated')) {
    return event + ` (${format(status_updated_at, 'MM/DD/YYYY')})`;
  } else if (event && event.toLowerCase().includes('accepted at office')) {
    return "Your shipment has been accepted by our forwarding  partner and is on the way to your doorstep."
  } else if (event && event.toLowerCase().includes('accepted at lbc express inc')) {
    return "Your shipment has been accepted by our forwarding  partner and is on the way to your doorstep."
  } else if (event && event.toLowerCase().includes('accepted at branch south san francisco')) {
    return "Your shipment has been accepted by our forwarding  partner and is on the way to your doorstep."
  }
  return event
}

export function ellipses (word, clipper) {
  if (word.length > clipper) return `${word.substring(0, clipper - 2)}...`
  return word
}

export function numbersWithComma (x) {
  const parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function maskAddressErrorMessage (msg, country) {
  if (country === "MY") {
    if (msg.includes("barangay")) {
      return msg.replace("barangay", "district/barangay")
    } else if (msg.includes("province")) {
      return msg.replace("province", "state/province")
    }
  }

  return msg
}

export function maskLocationName (location) {
  switch (location) {
    case "US":
      return "US";
    case "UK":
      return "UK";
    case "MY":
      return "Malaysia";
    case "PH":
      return "Philippines";
    default:
      return location;
  }
}

export function maskRedirectLink (type, reference_id) {
  switch (type.redirection_type) {
    case "prohibited":
      return "/prohibited";
    case "item_details":
      return /parcel/ + type.item_id;
    case "order_details":
      return /track/ + type.tracking_number;
    case "payment_success":
      return /track/ + type.tracking_number;
    case "payment_failed":
      return `/shipment#` + reference_id;
    case "package_accepted":
      return `/help-center#delivery`;
    case "delivered":
      return window.location.pathname;
    case "vas_completed":
    case "vas_approved":
    case "vas_rejected":
    case "vas_payment_success":
    case "vas_payment_failed":
      return /parcel/ + type.parcel_id;
    case "terms_and_conditions":
      return "/terms-conditions";
    default:
      return type;
  }
}

export function isMigratedEventRemarks (remark_date) {
  return isBefore(format(remark_date, 'MM/DD/YYYY HH:mm:ss'), format('2018-03-08', 'MM/DD/YYYY HH:mm:ss'))
}

export function extensionDetect (extensionId) {
  const script = document.createElement('script');
  script.onload = function () { setExtDetect(true); };
  script.onerror = function () { setExtDetect(false); };
  script.src = 'chrome-extension://' + extensionId + '/assets';
  document.body.appendChild(script);
}

function setExtDetect (value) {
  if (value) {
    localStorage.setItem("cartExtensionModalShowed", value)
  }
}

export function netcoreScript (accountNumber) {
  window.smartech('create', 'ADGMOT35CHFLVDHBJNIG50K969R5IJDR7QSKURD40EMEKF18IN70');
  window.smartech('register', '5cbfa9252c18508b714b90fa118de653');
  window.smartech('identify', accountNumber ? accountNumber : ""); // under '', please pass the EMAIL of web visitor. Else please do not pass any value
  window.smartech('dispatch', 1, {});
};

export const disabledCart = false

export const adminUserIds = [
  '34-673340',
  '20-595738',
  '61-854920',
  '77-363736',
  '65-276502',
  '70-769683',
  '87-260932',
  '39-583168',
  '64-106181',
  '12-420535',
  '36-466687',
  '28-615882',
  '27-408808',
];

export function maskOriginID (origin) {
  switch (origin) {
    case "US":
      return 1;
    case "UK":
      return 2;
    case "AU":
      return 3;
    case "KR":
      return 4;
    case "JP":
      return 5;
    case "OR":
      return 6;
    default:
      return 6;
  }
}

export function prefixNumber (prefix) {
  switch (prefix) {
    case '+63':
    case '+60':
    case '001':
    case '+44':
    case '+61':
    case '+82':
    case '+81':
      return true;
    default:
      return false;
  }
}

export const mapPrefixNumber = [
  { value: "+63", label: "PH +63" },
  { value: "+60", label: "MY +60" },
  { value: "001", label: "US 001" },
  { value: "+44", label: "UK +44" },
  { value: "+61", label: "AU +61" },
  { value: "+82", label: "KR +82" },
  { value: "+81", label: "JP +81" },
]

export const adyenDropInAccount = [
  //staging
  '46-258241',
  '14-101899',
  '55-498385',
  '53-228572',
  '53-504119',
  '81-765901',
  '91-174784',
  //prod
  '87-260932',
  '39-583168',
  '85-226208',
  '63-295648'
];

export function handleEnvironment (prefix) {
  const url = appConfig.scApiUrl;
  if (url.includes('locahost')) {
    return 'test';
  }
  if (url.includes('dev')) {
    return 'test';
  }
  if (url.includes('staging')) {
    return 'test';
  }
  return 'live';
};

export function maskCartWarehouseLabel (location, filterWarehouse) {
  if (filterWarehouse) {
    switch (location.id) {
      case 1:
      case 6:
        return "US";
      default:
        return location.country_code;
    }
  }
  return location.country_code;
}


export function maskWarehouseById (id) {
  switch (id) {
    case 1:
      return "CA,US";
    case 2:
      return "UK";
    case 3:
      return "AU";
    case 4:
      return "KR";
    case 5:
      return "JP";
    case 6:
      return "OR,US";
    default:
      return id;
  }
}


/** WEBPACK FOOTER **
 ** ./src/utils/utils.js
 **/